import type { bloomreachEventsConfig } from '@/shared/lib';

import {
  collectPropertiesUpToEvent,
  type AnalyticsEventNameType,
} from '../../analytics-events-storage';

/**
 * Collects properties from all previous bloomreach events up to (but not including) the given event
 * This uses the shared analytics events storage logic to avoid code duplication
 *
 * @param event - The bloomreach event name to collect properties up to
 * @returns Merged properties from all previous events in the flow
 */
export const collectProperties = (
  event: bloomreachEventsConfig.BloomreachEventName,
) => {
  // Bloomreach event names are the same string values as analytics event names
  // Convert to string to ensure type compatibility
  return collectPropertiesUpToEvent(String(event) as AnalyticsEventNameType);
};
